import { useMutation } from "@tanstack/react-query";

import { axios } from "@/client/libs/axios";

import { syncResumeMutationCache } from "./cache";

type LockResumeArgs = {
  id: string;
  set: boolean;
};

export const lockResume = async ({ id, set }: LockResumeArgs) => {
  const response = await axios.patch(`/resume/${id}/lock`, { set });

  await syncResumeMutationCache(response.data);

  return response.data;
};

export const useLockResume = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: lockResumeFn,
  } = useMutation({
    mutationFn: lockResume,
  });

  return { lockResume: lockResumeFn, loading, error };
};
